import { render, staticRenderFns } from "./screening-task-content.vue?vue&type=template&id=503c21c2&scoped=true"
import script from "./screening-task-content.vue?vue&type=script&lang=js"
export * from "./screening-task-content.vue?vue&type=script&lang=js"
import style0 from "./screening-task-content.vue?vue&type=style&index=0&id=503c21c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503c21c2",
  null
  
)

export default component.exports